/**
 * Internal SKU code → display rendering, per docs/cycloud-platform-reference.md.
 *
 * Layer 1 (internal code, e.g. CY-ST-02) is NEVER customer-facing.
 * Layer 2 (technical identifier, e.g. Gen1i.M) appears as subtitle in mono.
 * Layer 3 (display name, e.g. CyCloud M) is the primary customer-facing string.
 */

export interface SkuRendering {
  displayName: string
  technicalIdentifier: string
  platformLine: string
}

const SKU_TABLE: Record<string, SkuRendering> = {
  'CY-ST-01': {
    displayName: 'CyCloud S',
    technicalIdentifier: 'Gen1i.S',
    platformLine: 'Dell PowerEdge R670 · Intel Xeon 6 · 64 cores',
  },
  'CY-ST-02': {
    displayName: 'CyCloud M',
    technicalIdentifier: 'Gen1i.M',
    platformLine: 'Dell PowerEdge R770 · Intel Xeon 6 · 96 cores',
  },
  'CY-ST-03': {
    displayName: 'CyCloud L',
    technicalIdentifier: 'Gen1i.L',
    platformLine: 'Dell PowerEdge R770 · Intel Xeon 6 · 144 cores',
  },
}

export function renderSku(internalCode: string): SkuRendering {
  return (
    SKU_TABLE[internalCode] ?? {
      displayName: 'CyCloud',
      technicalIdentifier: internalCode,
      platformLine: 'Dell PowerEdge · Intel Xeon 6 · vSAN ESA all-NVMe',
    }
  )
}
